export interface IStepInfo {
  id: string;
  title: string;
  error?: string;
  showPreviousNext?: boolean;
}

export const CustomisationStepsInfo = {
  INCLUDE_ALL_LESSONS: {
    id: 'include_all_lessons',
    title: 'Which sessions would you like to add to plan?'
  },
  START_DATE: {
    id: 'start_date',
    title: 'When do you want to start learning this course?',
    error: 'Please select when you want to start learning',
    showPreviousNext: true
  },
  DAYS: {
    id: 'days',
    title: 'Which days would you like to learn on?',
    error: 'Please select which days you want to learn',
    showPreviousNext: true
  },
  LESSON_TIME: {
    id: 'time',
    title: 'What is your preferred time?',
    showPreviousNext: true
  }
};

export const CustomizationStepsWithoutLessons: IStepInfo[] = [
  CustomisationStepsInfo.START_DATE,
  CustomisationStepsInfo.DAYS,
  CustomisationStepsInfo.LESSON_TIME
];

export const AllCustomizationSteps: IStepInfo[] = [
  CustomisationStepsInfo.INCLUDE_ALL_LESSONS,
  CustomisationStepsInfo.START_DATE,
  CustomisationStepsInfo.DAYS,
  CustomisationStepsInfo.LESSON_TIME
];

export const EditCustomizationSteps: IStepInfo[] = [
  CustomisationStepsInfo.DAYS,
  CustomisationStepsInfo.LESSON_TIME
];
